module.exports = __webpack_public_path__ + "img/persona_shortcode.76ef1d1c.png";